import url from "./url";
function logger(key, value) {
    if (value === void 0) { value = 1; }
    var reportScript;
    var k = key.replace(/\./g, "-");
    var spmPrefix = url.getMetaTag("spm_prefix");
    var isBiliHttps = location.href.indexOf("bilihttps") === 0;
    if (!spmPrefix) {
        var meta = document.createElement("meta");
        meta.name = "spm_prefix";
        meta.content = "888.1";
        document.getElementsByTagName("head")[0].appendChild(meta);
    }
    if (!window.reportObserver) {
        window.reportMsgObj = {};
        window.reportConfig = {
            sample: 1,
            scrollTracker: false,
            msgObjects: "reportMsgObj",
            errorTracker: true,
        };
        reportScript = document.createElement("script");
        reportScript.src = (isBiliHttps ? "bilihttps:" : "") + "//s1.hdslb.com/bfs/seed/log/report/log-reporter.js";
        document.getElementsByTagName("body")[0].appendChild(reportScript);
    }
    var doReport = function () {
        try {
            window.reportMsgObj &&
                window.reportObserver &&
                ((window.reportMsgObj[k] = value),
                    window.reportObserver.forceCommit &&
                        window.reportObserver.forceCommit());
        }
        catch (error) {
            console.error("[logger]", error);
        }
    };
    if (reportScript) {
        reportScript.onload = doReport;
    }
    else {
        doReport();
    }
}
export default logger;
//# sourceMappingURL=logger.js.map